import { useContext } from "react";
import UserContext from "../../context/User/UserContext";

const UserData = () => useContext(UserContext);

export default UserData;
